export default __webpack_public_path__ + "static/media/person_3.bd0b83d0.png";